import { render, staticRenderFns } from "./JSlider.vue?vue&type=template&id=71834452&scoped=true&"
import script from "./JSlider.vue?vue&type=script&lang=js&"
export * from "./JSlider.vue?vue&type=script&lang=js&"
import style0 from "./JSlider.vue?vue&type=style&index=0&id=71834452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71834452",
  null
  
)

export default component.exports